import React, { useState } from "react";

import Modal from "components/modal";
import FeedbackContainer from "components/feedback-framework";

import useProfile from "hooks/useProfile";

import { FEEDBACK_JOURNEY, FEEDBACK_REQUEST_TYPE } from "../constants";
import { faOnFeedbackClick } from "../services/analytics";

import styles from "./searchFeedback.scss";

const { search_feedback, feedback_text } = styles;

export default function SearchFeedback({ lob, partyDetails, profile, product }) {
  const { isAuth } = useProfile();
  const [isOpen, setIsOpen] = useState(false);
  const { contents } = profile || {};
  const { olmId, personalInfo } = contents || {};
  const { emailId, userName, communicationNumber } = personalInfo || {};
  const { partyId } = partyDetails || "";

  const handleFeedbackClick = () => {
    faOnFeedbackClick();
    setIsOpen(true);
  };

  const feedbackPayload = {
    requestType: FEEDBACK_REQUEST_TYPE,
    journey: FEEDBACK_JOURNEY,
    lob,
    partyId,
    product,
    unauthJourney: !isAuth,
    customerInformation: { email: emailId, name: userName, mobile: communicationNumber, olmId },
    requesterInformation: { email: emailId, name: userName, mobile: communicationNumber, olmId },
  };
  const body = (
    <FeedbackContainer payload={feedbackPayload} viewType={"Modal"} showCloseBtn={true} onClose={() => setIsOpen(false)} />
  );

  return (
    <div className={search_feedback}>
      <div className={feedback_text} onClick={handleFeedbackClick}>
        Feedback
      </div>
      {isOpen && <Modal body={body} onCloseClick={() => setIsOpen(false)} />}
    </div>
  );
}
